





















































import Vue from 'vue'
import Component from 'vue-class-component'
import * as t from '@/types'
import steps from '@/steps'
import { Getter, Mutation, Action } from 'vuex-class'
import store from '@/store'

import resultChart from '@/components/resultChart.vue'
import resultPie from '@/components/resultPie.vue'
import navigation from '@/components/navigation.vue'

@Component({
  components: { resultChart, resultPie, navigation },
})
export default class Results extends Vue {
  private currencySymbol = t.currencySymbol
  private steps = steps
  @Mutation private setStepReached!: (step: number) => void
  @Action private saveData!: () => void

  @Getter private isStepCompleted!: (step: t.StepDefinition) => boolean
  @Getter private annualIncome!: number
  @Getter private annualHousehold!: number
  @Getter private annualDay2Day!: number
  @Getter private annualPersonal!: number
  @Getter private annualDebtRepayments!: number
  @Getter private annualProtection!: number
  @Getter private annualSavingsPayments!: number
  @Getter private annualExpenses!: number
  @Getter private monthlyDifference!: number
  @Getter private monthlyIncome!: number
  @Getter private monthlyExpenses!: number

  async mounted () {
    this.setStepReached(8)
    await this.saveData()
  }

  get budgetData () {
    return [
      // { value: this.annualIncome, tooltip: `Income: ${this.currencySymbol}${this.annualIncome}` },
      {
        value: this.annualHousehold / 12,
        link: steps.step2.link,
        tooltip: `Household: ${this.currencySymbol}${(this.annualHousehold / 12).toFixed(0)}`
      },
      {
        value: this.annualDay2Day / 12,
        link: steps.step3.link,
        tooltip: `Day2Day: ${this.currencySymbol}${(this.annualDay2Day / 12).toFixed(0)}`
      },
      {
        value: this.annualPersonal / 12,
        link: steps.step4.link,
        tooltip: `Personal: ${this.currencySymbol}${(this.annualPersonal / 12).toFixed(0)}`
      },
      {
        value: this.annualDebtRepayments / 12,
        link: steps.step5.link,
        tooltip: `Debt Repayments: ${this.currencySymbol}${(this.annualDebtRepayments / 12).toFixed(0)}`
      },
      {
        value: this.annualProtection / 12,
        link: steps.step6.link,
        tooltip: `Protection: ${this.currencySymbol}${(this.annualProtection / 12).toFixed(0)}`
      },
      {
        value: this.annualSavingsPayments / 12,
        link: steps.step7.link,
        tooltip: `Savings Payments: ${this.currencySymbol}${(this.annualSavingsPayments / 12).toFixed(0)}`
      },
    ]
  }
}
